module.exports = __webpack_public_path__ + "img/sx.sx3721436.svg";